import React from 'react'
import { AppRoute } from 'src/navigation/appRoutes'
import { ssoCallbackRouteProps } from 'src/navigation/routeProps'
import SsoCallbackPage from 'src/page-components/SsoCallbackPage/SsoCallbackPage'

import { AppLocation } from '../appLocations'

const SsoCallbackAppRoute: AppRoute = {
  id: AppLocation.SsoCallback,
  routeProps: ssoCallbackRouteProps,
  component: <SsoCallbackPage />,
  subRoutes: [],
}

export default SsoCallbackAppRoute
